
document.addEventListener('DOMContentLoaded', function () {
  let pricingCV2 = document.querySelector('.js-pricing-v2')
  let prods = window.product || []

  let pro_options = window.options || []
  let $priceDom = document.getElementById('sp_price1')
  let $cPriceDom = document.getElementById('sp_price2')
  let currentSelections = {} // 唯一声明：避免重复
  const PRICE_REGEX = /\d+(?:[.,]\d+)*/
  const OFF_REGEX = /(\d+)(?=(?:<[^>]+>|\s)*%)/g

  // 提前定义核心函数changePrice（解决调用前置问题）
  function changePrice() {
    const $numDom = document.querySelector('.js-Antal-value')
    // 全量判空：任一核心变量不存在，直接返回
    //  console.log($priceDom,$cPriceDom,$numDom,"currentText")
    if (!pricingCV2 || !prods.length || !$priceDom || !$cPriceDom || !$numDom)
      return

    // 获取当前选中变体
    const curVariant = getCur()
    //  console.log(curVariant,"currentText")
    if (!curVariant || !curVariant.price) return

    // 获取数量：简化逻辑+防非数字
    const numText = $numDom.textContent?.trim() || '1'
    const num =
      !isNaN(Number(numText)) && Number(numText) > 0 ? Number(numText) : 1

    // 解析价格格式（保留原逻辑）
    const currentText = $priceDom.textContent.trim()
    // console.log(currentText,"currentText")
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/)
    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0

    // 价格格式化函数
    const formatValue = cents => {
      let val = ((cents * num) / 100).toFixed(decimalLength)
      return decimalSeparator === ',' ? val.replace('.', ',') : val
    }

    // 计算价格/折扣
    const price = formatValue(curVariant.price)
    const compare = curVariant.compare_at_price
      ? formatValue(curVariant.compare_at_price)
      : price
    let offPercent = 0
    if (
      curVariant.compare_at_price &&
      curVariant.compare_at_price > curVariant.price
    ) {
      offPercent =
        100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100)
    }

    // jQuery对象更新HTML（增加判空）
// 原生JS版 updateHTML：替换指定元素的文本（正则匹配），避免重复更新DOM
const updateHTML = (el, regex, value) => {
  // 严格判空：确保el是有效原生DOM元素（排除null/undefined/非DOM对象）
  if (!el || !(el instanceof HTMLElement)) return;
  
  // 1. 获取元素纯文本并去空格（和原jQuery逻辑一致）
  const text = el.textContent.trim();
  // 2. 正则替换目标内容，得到新的HTML
  const newHtml = text.replace(regex, value);
  // 3. 对比新旧内容，不同时才更新（避免重复操作DOM，提升性能）
  if (el.innerHTML !== newHtml) {
    el.innerHTML = newHtml;
  }
};

    // 更新价格/折扣
    updateHTML($priceDom, PRICE_REGEX, price)
    updateHTML($cPriceDom, PRICE_REGEX, compare)
    // 折扣元素判空
    const offEl = pricingCV2?.querySelector('.font-off')
    if (offEl) offEl.textContent = offPercent
  }

  function getCur() {
   
    if (!prods.length || Object.keys(currentSelections).length === 0)
      return null
    // 按索引排序选中值，生成匹配条件
    const selectedVals = Object.keys(currentSelections)
      .sort((a, b) => Number(a) - Number(b))
      .map(k => currentSelections[k])
    // 动态匹配option1/option2/option3...（兼容任意分组数）

    return prods.find(item => {
      return selectedVals.every((val, idx) => {
        const optionKey = `option${idx + 1}`
        return (
          item[optionKey] === pro_options[idx]?.values[val]
        )
      })
    })
  }
  pricingCV2
    ?.querySelector('.sp-buy-now')
    ?.addEventListener('click', function () {
      let num =
        document.querySelector('.js-Antal-value')?.textContent?.trim() || 1
      let id = getCur().id

      window.location.href = '/cart/' + id + ':' + num
    })
  // FAQ Toggle
  const faqItems = document.querySelectorAll('.js-faq-item')
  faqItems.forEach(item => {
    const trigger = item.querySelector('.js-faq-trigger')
    const content = item.querySelector('.js-faq-content')
    const icon = item.querySelector('.js-faq-icon')

    trigger.addEventListener('click', () => {
      const isOpen =
        content.style.maxHeight && content.style.maxHeight !== '0px'
      if (isOpen) {
        content.style.maxHeight = '0px'
        content.style.opacity = '0'
        content.style.paddingBottom = '0px'
        if (icon) icon.style.transform = 'rotate(0deg)'
      } else {
        content.style.maxHeight = content.scrollHeight + 'px'
        content.style.opacity = '1'
        content.style.paddingBottom = '16px'
        if (icon) icon.style.transform = 'rotate(180deg)'
      }
    })
  })

  // Comparison Slider (Before/After)
  const sliders = document.querySelectorAll('.js-comparison-slider')
  sliders.forEach(slider => {
    const topImageDiv = slider.querySelector('.js-top-image')
    const topImg = topImageDiv ? topImageDiv.querySelector('img') : null
    const handle = slider.querySelector('.js-slider-handle')
    let isDown = false
    let isHover = false

    // Fix: Ensure the inner image width matches the container width to prevent resizing/distortion
    function syncImageWidth() {
      if (topImg) topImg.style.width = slider.offsetWidth + 'px'
    }
    syncImageWidth()
    window.addEventListener('resize', syncImageWidth)

    function updateSlider(x) {
      const rect = slider.getBoundingClientRect()
      let pos = ((x - rect.left) / rect.width) * 100
      if (pos < 0) pos = 0
      if (pos > 100) pos = 100
      if (topImageDiv) topImageDiv.style.width = pos + '%'
      if (handle) handle.style.left = pos + '%'
    }

    // Auto Animation Loop
    function animate() {
        // console.log(isDown,"isDown")
        // console.log(isHover,"isHover")
      if (!isDown && !isHover) {
        const time = Date.now()
        const newPos = 50 + 35 * Math.sin(time / 1500)
        if (topImageDiv) topImageDiv.style.width = newPos + '%'
        if (handle) handle.style.left = newPos + '%'
      }
      requestAnimationFrame(animate)
    }
    requestAnimationFrame(animate)

    // Drag Events
    slider.addEventListener('mousedown', () => (isDown = true))
    slider.addEventListener('touchstart', () => (isDown = true))
    window.addEventListener('mouseup', () => (isDown = false))
    window.addEventListener('touchend', () => (isDown = false))

    slider.addEventListener('mouseenter', () => (isHover = true))
    slider.addEventListener('mouseleave', () => {
      isHover = false
      isDown = false
    })

    slider.addEventListener('mousemove', e => {
      if (!isDown) return
      updateSlider(e.clientX)
    })
    slider.addEventListener('touchmove', e => {
      if (!isDown) return
      updateSlider(e.touches[0].clientX)
    })
  })

  // Carousel Scroll Buttons (for Comparison Carousel)
  document.querySelectorAll('.js-carousel-prev').forEach(btn => {
    btn.addEventListener('click', e => {
      const container = e.target
        .closest('.group')
        .querySelector('.js-carousel-container')
      if (container)
        container.scrollBy({ left: -container.clientWidth, behavior: 'smooth' })
    })
  })
  document.querySelectorAll('.js-carousel-next').forEach(btn => {
    btn.addEventListener('click', e => {
      const container = e.target
        .closest('.group')
        .querySelector('.js-carousel-container')
      if (container)
        container.scrollBy({ left: container.clientWidth, behavior: 'smooth' })
    })
  })
  // dot跟随图片变化
  document.querySelectorAll('.js-carousel-container').forEach(container => {
  const group = container.closest('.group')
  const indicators = group.querySelectorAll('.js-comparison-dot')

  if (!indicators.length) return

  const updateDots = () => {
    const index = Math.round(container.scrollLeft / container.clientWidth)

    indicators.forEach((dot, i) => {
      if (i === index) {
        dot.classList.remove('bg-gray-300')
        dot.classList.add('bg-gray-800', 'w-4')
      } else {
        dot.classList.remove('bg-gray-800', 'w-4')
        dot.classList.add('bg-gray-300')
      }
    })
  }

  // 滚动时更新（箭头 / 拖动 都会触发）
  container.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateDots)
  })

  // 初始状态校准一次
  updateDots()
})
  // 无限滚动：替代scrollLeft，用绝对定位实现自动+手动滑动
const infiniteScrolls = document.querySelectorAll('.js-infinite-scroll');
infiniteScrolls.forEach(container => {
  // ========== 1. 初始化DOM结构（创建wrapper包裹所有子元素） ==========
  // 把原有子元素移到wrapper里（避免破坏结构）
  const wrapper = document.createElement('div');
  wrapper.className = 'infinite-scroll-wrapper';
  // 保存原有子元素
  while (container.firstChild) {
    wrapper.appendChild(container.firstChild);
  }
  container.appendChild(wrapper);

  // ========== 2. 初始化样式（核心：父相对定位，子绝对定位） ==========
  Object.assign(container.style, {
    position: 'relative',       // 作为wrapper的定位参考
    overflow: 'hidden',         // 隐藏超出的wrapper部分
    userSelect: 'none',         // 禁止文字选中
    cursor: 'grab',
    height: "375px",
    width: '100%'               // 固定父容器宽度
  });

  // wrapper样式：绝对定位，横向排列，宽度自适应子元素
  Object.assign(wrapper.style, {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',            // 强制子元素横向排列
    gap: '16px',                // 子元素间距（可自定义）
    whiteSpace: 'nowrap',       // 兜底防止换行
    transition: 'none'          // 自动滚动不需要过渡，避免卡顿
  });

  // 强制子元素横向排列（兜底）
  Array.from(wrapper.children).forEach(child => {
    Object.assign(child.style, {
      flex: '0 0 auto',         // 不缩放，固定宽度
      width: '300px'            // 子元素固定宽度（可自定义）
    });
  });

  // ========== 3. 初始化变量 ==========
  let isDragging = false;       // 是否正在拖拽
  let startX = 0;               // 拖拽起始X坐标
  let startLeft = 0;            // 拖拽起始时wrapper的left值
  let animationId = null;       // 自动滚动的动画帧ID
  const scrollSpeed = 1;        // 自动滚动速度（px/帧，越大越快）

  // ========== 4. 计算边界（wrapper超出父容器的宽度） ==========
  function getBoundaries() {
    const containerWidth = container.offsetWidth;
    const wrapperWidth = wrapper.offsetWidth;
    const maxLeft = 0;                          // 最右侧边界（left=0）
    const minLeft = containerWidth - wrapperWidth; // 最左侧边界（完全展示最后一个子元素）
    return { maxLeft, minLeft, wrapperWidth, containerWidth };
  }

  // ========== 5. 手动拖拽逻辑（替代scrollLeft拖拽） ==========
  // 开始拖拽（鼠标/触摸）
  function handleStart(e) {
    isDragging = true;
    container.style.cursor = 'grabbing';
    // 兼容鼠标/触摸坐标
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    startX = clientX;
    startLeft = parseFloat(wrapper.style.left) || 0;
    // 停止自动滚动
    cancelAnimationFrame(animationId);
  }

  // 拖拽中（鼠标/触摸）
  function handleMove(e) {
    if (!isDragging) return;
    e.preventDefault(); // 阻止默认行为（比如页面滚动）
    // 兼容鼠标/触摸坐标
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    // 计算拖拽偏移量（向右拖=正，向左拖=负）
    const deltaX = clientX - startX;
    // 计算新的left值（限制在边界内）
    const { maxLeft, minLeft } = getBoundaries();
    let newLeft = startLeft + deltaX;
    // 限制拖拽范围（不超出左右边界）
    newLeft = Math.min(maxLeft, Math.max(minLeft, newLeft));
    // 移动wrapper
    wrapper.style.left = `${newLeft}px`;
  }

  // 结束拖拽（鼠标/触摸）
  function handleEnd() {
    if (!isDragging) return;
    isDragging = false;
    container.style.cursor = 'grab';
    // 重启自动滚动
    autoScroll();
  }

  // ========== 6. 自动滚动逻辑（替代scrollLeft += 0.5） ==========
  function autoScroll() {
    // 终止条件：拖拽中 / wrapper宽度 ≤ 容器宽度（无需滚动）
    const { wrapperWidth, containerWidth, maxLeft, minLeft } = getBoundaries();
    if (isDragging || wrapperWidth <= containerWidth) {
      cancelAnimationFrame(animationId);
      animationId = null;
      return;
    }

    // 获取当前left值
    let currentLeft = parseFloat(wrapper.style.left) || 0;
    // 向左移动（left值递减）
    currentLeft -= scrollSpeed;

    // 边界重置：滚动到最左侧后，回到最右侧（无限循环）
    if (currentLeft < minLeft - 50) { // 多滚50px，避免卡顿
      currentLeft = maxLeft;
    }

    // 应用新的left值
    wrapper.style.left = `${currentLeft}px`;

    // 持续递归，实现自动滚动
    animationId = requestAnimationFrame(autoScroll);
  }

  // ========== 7. 绑定事件（兼容鼠标+触摸） ==========
  // 鼠标事件
  container.addEventListener('mousedown', handleStart);
  document.addEventListener('mousemove', handleMove);
  document.addEventListener('mouseup', handleEnd);
  document.addEventListener('mouseleave', handleEnd);

  // 触摸事件（iOS/安卓核心）
  container.addEventListener('touchstart', handleStart, { passive: true });
  document.addEventListener('touchmove', handleMove, { passive: false });
  document.addEventListener('touchend', handleEnd);

  // ========== 8. 初始化自动滚动 ==========
  // 延迟初始化，确保DOM尺寸计算准确
  setTimeout(() => {
    autoScroll();
  }, 300);

  // 窗口大小变化时，重新计算边界并重启滚动
  window.addEventListener('resize', () => {
    cancelAnimationFrame(animationId);
    autoScroll();
  });
});
      
  // Pricing V2 Logic
  const pricingV2 = document.querySelector('.js-pricing-v2')
  if (pricingV2) {
    // Countdown
    const hEl = pricingV2.querySelector('.js-timer-h')
    const mEl = pricingV2.querySelector('.js-timer-m')
    const sEl = pricingV2.querySelector('.js-timer-s')
    let timeLeft = 43749

    setInterval(() => {
      timeLeft = timeLeft > 0 ? timeLeft - 1 : 43749
      const h = Math.floor(timeLeft / 3600)
      const m = Math.floor((timeLeft % 3600) / 60)
      const s = timeLeft % 60
      if (hEl) hEl.textContent = String(h).padStart(2, '0')
      if (mEl) mEl.textContent = String(m).padStart(2, '0')
      if (sEl) sEl.textContent = String(s).padStart(2, '0')
    }, 1000)

    // Variants
    const variantImages = JSON.parse(
      pricingV2.getAttribute('data-variant-images') || '{}'
    )
    const variantBadges = JSON.parse(
      pricingV2.getAttribute('data-variant-badges') || '{}'
    )
    const mainImage = pricingV2.querySelector('.js-main-image')
    const shippingBadge = pricingV2.querySelector('.js-shipping-badge')

    const groups = pricingV2.querySelectorAll('.js-variant-group')

    function updateVariant() {
      const key = Object.keys(currentSelections)
        .sort()
        .map(k => currentSelections[k])
        .join('-')
      if (variantImages[key] && mainImage) {
        mainImage.src = variantImages[key]
      }
      if (shippingBadge) {
        if (variantBadges[key] !== false) {
          shippingBadge.style.display = 'flex'
        } else {
          shippingBadge.style.display = 'none'
        }
      }
      changePrice()
    }

    groups.forEach((group, gIdx) => {
      const btns = group.querySelectorAll('.js-variant-btn')
      currentSelections[gIdx] = 0

      btns.forEach((btn, bIdx) => {
        btn.addEventListener('click', () => {
          btns.forEach(b => {
            b.classList.remove('border-black', 'bg-black', 'text-white')
            b.classList.add('border-gray-200', 'text-gray-600')
          })
          btn.classList.remove('border-gray-200', 'text-gray-600')
          btn.classList.add('border-black', 'bg-black', 'text-white')

          currentSelections[gIdx] = bIdx
          updateVariant()
        })
      })
    })
  }

/**
 * 创建吐司弹窗
 * @param {string} text - 弹窗要显示的文字内容
 */
function showToast(text) {
  // 1. 先移除页面中已有的吐司（避免重复创建）
  const oldToast = document.querySelector('.toast-popup');
  if (oldToast) oldToast.remove();

  // 2. 创建吐司DOM元素
  const toast = document.createElement('div');
  toast.className = 'toast-popup';
  
  // 3. 设置吐司样式（核心：居中、黑透明、白字）
  toast.style.cssText = `
    position: fixed; /* 固定定位，相对于视口居中 */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); /* 真正的屏幕正中间 */
    background: rgba(0, 0, 0, 0.7); /* 黑色半透明（0.7是透明度，可调整） */
    color: #ffffff; /* 白色文字 */
    padding: 12px 20px; /* 内边距，优化视觉 */
    border-radius: 8px; /* 圆角，更美观 */
    font-size: 12px; /* 文字大小 */
    z-index: 99999; /* 最高层级，避免被遮挡 */
    pointer-events: none; /* 不遮挡页面点击 */
    text-align: center; /* 文字居中 */
    max-width: 80%; /* 适配小屏幕，文字不溢出 */
  `;

  // 4. 设置弹窗文字内容
  toast.textContent = text;

  // 5. 添加到页面body中
  document.body.appendChild(toast);

  // 6. 1秒后自动移除弹窗
  setTimeout(() => {
    // 加淡出动画（可选，更丝滑）
    toast.style.transition = 'opacity 0.3s ease';
    toast.style.opacity = 0;
    // 动画结束后移除元素
    setTimeout(() => {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 300);
  }, 1000); // 核心：展示1秒（1000ms）
}
// 绑定点击事件（替代$(document).on("click", ".sp_add_cart", ...)）
document.addEventListener('click', function(e) {
  // 找到点击的.sp_add_cart元素（兼容子元素点击）
  const addCartBtn = e.target.closest('.js-add-to-cart');
  if (!addCartBtn) return;

  // ========== 1. 购物车加购动效（替换jQuery的addClass/removeClass/setTimeout） ==========
  // 按钮图片添加on类
  const btnImgs = addCartBtn.querySelectorAll('img');
  btnImgs.forEach(img => img.classList.add('on'));
  
  // 显示购物车数字
  const cartNumEls = document.querySelectorAll('.sp-num');
  cartNumEls.forEach(el => el.style.display = 'block');
  
  // 500ms后移除按钮图片的on类（原$(" .cart-btn").children("img") → 修正为addCartBtn的img，避免选择器错误）
  setTimeout(function() {
    const cartBtnImgs = document.querySelectorAll('.sp-num img');
    cartBtnImgs.forEach(img => img.classList.remove('on'));
  }, 500);
  
  // 购物车添加on类，500ms后移除
  const spCartEls = document.querySelectorAll('.sp-num');
  spCartEls.forEach(el => el.classList.add('on'));
  setTimeout(function() {
    spCartEls.forEach(el => el.classList.remove('on'));
  }, 500);

  // ========== 2. AJAX加购（替换$.ajax/$.getJSON） ==========
  // 构造加购数据（需确保getCur()函数已定义，返回当前选中变体）
  const numDom = document.querySelector('.js-Antal-value')
  console.log(numDom,"numDom")
  const numText = numDom.textContent?.trim() || '1'
  const data = {
    id: getCur().id,
    quantity: numText // 判空兜底，避免报错
  };

  // 原生fetch发送POST请求（替代$.ajax）
   $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
          })
          $('.cardNum').removeClass('sp-gray')
        })
      },
      dataType: 'json',
    })
    
    if (document.body.clientWidth > 1080){
            var imgs =  $('.js-main-image')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.js-pricing-v2').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',

        top: $img[0].offsetTop,
        left: $img.offset().left,
        'z-index': 99999,
      })
       let finish = $('.cardNum');
        const finishRect = finish[0].getBoundingClientRect(); // 获取.cardNum的视口坐标
        const isFlyerFixed = $(flyer).css('position') === 'fixed'; // 判断flyer的定位类型

        // ===== 正确的top值计算 =====
        let targetTop;
        if (isFlyerFixed) {
        // 情况1：flyer是fixed定位（参考视口）
        // 计算.cardNum垂直中心 - flyer最终高度的一半（25px），保证中心对齐
        targetTop = finishRect.top + (finishRect.height / 2) - 25;
        } else {
        // 情况2：flyer是absolute定位（参考文档）
        // 视口top + 页面垂直滚动偏移 - flyer半高
        targetTop = (finishRect.top + window.scrollY) + (finishRect.height / 2) - 25;
        }

        $(flyer).animate(
          {
           top: targetTop, // 动态计算的top（替代-100）
            left: finishRect.left + (finishRect.width / 2) - 25, // 之前修正的left
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )

    })
    }else {
        showToast("Tillagt i kundvagnen!")
    }
    
});
var links = document.querySelectorAll('a[href^="#section-2mhxwcjc9"]')
links.forEach(function (link) {
  link.addEventListener('click', function (event) {
    // 1. 确保阻止默认事件（加安全判断，避免event为undefined）
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault(); // 阻止a标签默认锚点跳转
      event.stopPropagation(); // 可选：阻止事件冒泡，避免冲突
    }

    // 2. 获取目标元素（加容错，避免元素不存在报错）
    const targetElement = document.getElementById('section-2mhxwcjc9');
    if (!targetElement) {
     
      return;
    }

    // 3. 关键：获取准确的zoom值（转数字，避免字符串运算）
    const rootZoom = parseFloat($('div#root').css('zoom')) || 1; // 转成数字，默认1

    // 4. 优化sp-nav高度获取（兼容无jQuery/高度为0的情况）
    const spNavHeight = $('.sp-nav').length ? parseFloat($('.sp-nav').height()) : 0;

    // 5. 关键：替换offsetTop为准确的「文档顶部偏移」（兼容zoom和定位）
    // getBoundingClientRect().top + window.scrollY = 元素相对于文档顶部的原始偏移（未缩放）
    const targetDocTop = targetElement.getBoundingClientRect().top
    
    // 6. 保留你的移动端/桌面端判断逻辑，优化偏移计算
    const isMobile = document.body.clientWidth <= 1080;
    // 原始偏移（未缩放）= 移动端：目标偏移 - nav高度 | 桌面端：目标偏移
    const rawOffsetTop = isMobile ? (targetDocTop - spNavHeight) : targetDocTop;
    // 移动端/桌面端的sptop（保留你的值）
    let sptop = isMobile ? 60 : 1000;

    // 7. 计算最终滚动位置（考虑zoom缩放，且确保不小于0）
    const finalTop = Math.max(
      0, // 边界处理：避免滚动到页面外（top为负数）
      (rawOffsetTop * rootZoom) - (sptop * rootZoom)
    );
     targetElement.scrollIntoView({
      behavior: 'smooth', // 平滑滚动
      block: 'start',     // 对齐方式：元素顶部对齐视口顶部（可微调）
      inline: 'nearest'   // 横向默认对齐，无需修改
    });
    
    // 8. 平滑滚动（保留你的behavior: smooth）
  
  });
});

  document.querySelectorAll('.js-pricing-Antal').forEach(qtyContainer => {
    const minusBtn = qtyContainer.querySelector('.js-btn-minus')
    const plusBtn = qtyContainer.querySelector('.js-btn-plus')
    const valEl = qtyContainer.querySelector('.js-Antal-value')
    let val = 1

    if (minusBtn && plusBtn && valEl) {
      minusBtn.addEventListener('click', e => {
        e.stopPropagation()
        if (val > 1) {
          val--
          valEl.textContent = val
          changePrice()
        }
      })
      plusBtn.addEventListener('click', e => {
        e.stopPropagation()
        val++
        valEl.textContent = val
        changePrice()
      })
    }
  })

  // Reveal Animation
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('opacity-0', 'translate-y-12')
          entry.target.classList.add('opacity-100', 'translate-y-0')
        }
      })
    },
    { threshold: 0.1 }
  )
  document
    .querySelectorAll('.reveal-on-scroll')
    .forEach(el => observer.observe(el))
})
